import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const ServiceItem = ({ data }) => {
    const num = String(data.id).padStart(2, "0");
    return (
        <div className="col-lg-6 service-item-academic">
            <Link className="content" to={process.env.PUBLIC_URL + `/service-details/${data.id}`}>
                <span className="index">{num}</span>
                <div className="academic-body">
                    <div className="academic-header">
                        <h5 className="service-name">{data.title}</h5>
                        <span className="sub-title-en">{data.subTitle}</span>
                    </div>
                    <p>{data.excerpt}</p>
                    <span className="service-more">
                        상세 진료 안내 <i className="icofont-simple-right"></i>
                    </span>
                </div>
            </Link>
        </div>
    );
};

ServiceItem.propTypes = {
    data: PropTypes.object,
};

export default ServiceItem;
